import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import pepeAnimation from "../assets/pepe.json";

export default function Introduction() {
  const container = useRef(null);

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: container.current,
      animationData: pepeAnimation,
      autoplay: true,
      loop: true,
      renderer: "svg",
    });

    return () => {
      animation.destroy();
    };
  }, []);

  return (
    <div className="mt-20 text-white font-Londrina md:px-60 max-w-screen-4xl flex flex-col items-center">
        <div className="flex items-center mx-auto">
            <div className="w-full md:w-1/2 w-80 h-80" ref={container}></div>
            <div className="w-full md:w-1/2">
                <div className="text-2xl">INTRODUCING</div>
                <div className="text-9xl outlined-text">BASED PEPE</div>
                <div className="text-2xl">THE PEOPLE'S PEPE ON BASE</div>
            </div>
        </div>
        <div className="text-2xl text-center w-full mt-20 border-b-2 p-10">THIS MEME ICON HAS FOUND A NEW HOME</div>
    </div>
  );
}
